import React from 'react'

export const defaultCodesetsContext = {
    deniedReasons: []
};

export const CodesetsContext = React.createContext({codesets: defaultCodesetsContext, setCodesets: (values)=>{}});